export const environment = {
  production: true,
   baseURL: 'https://tiaano.in/api/',
  // baseURL: 'http://localhost/scalex_delivery_data/',
  authToken: 'ppvtech123'
};


